import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fiber-based-fabrics',
  templateUrl: './fiber-based-fabrics.component.html',
  styleUrls: ['./fiber-based-fabrics.component.css']
})
export class FiberBasedFabricsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
